/*
 * Antallsvelgeren på produktsiden, bare ved mer enn én (plan 19c-1, Emanuel 2026-10-30). Logikk: docs/varesystem/logikk/favoritter-tema.md.
 * Restlageret er lageret minus det som ligger i kurven, regnet på nytt ved variantbytte og etter hver endring i kurven.
 * - Varianten følges av Shopify og selges ikke uten lager: velgeren vises når restlageret er over 1, med max lik restlageret.
 *   Restlager 1: bare knappen. Restlager 0 eller mindre med varen i kurven: knappen er grå med «Alle ligger i handlekurven».
 * - Selges uten lager (continue): velgeren uten max. Følges ikke av Shopify: bare knappen.
 * Dataene står i <script data-gg-lager> i kjøpsskjemaet (sections/main-product.liquid), så hurtigkjøpet får dem også.
 */
(() => {
  if (window.ggAntallsvelger) return;
  window.ggAntallsvelger = true;

  const kurv = new Map(); // variant-ID -> antall i kurven
  let kurvLest = false;
  let kurvGen = 0; // øker ved hver kurvendring, så et eldre svar fra /cart.js aldri skriver over et nyere (codex 2026-10-30)

  function settKurv(items) {
    kurv.clear();
    (items || []).forEach((it) => {
      const id = String(Array.isArray(it) ? it[0] : it.variant_id);
      const antall = Number(Array.isArray(it) ? it[1] : it.quantity) || 0;
      kurv.set(id, (kurv.get(id) || 0) + antall);
    });
    kurvLest = true;
  }

  function data(el) {
    if (el.ggData === undefined) {
      try {
        el.ggData = JSON.parse(el.textContent);
      } catch (e) {
        el.ggData = null;
      }
    }
    return el.ggData;
  }

  function regn(el, variantId, variantByttet) {
    const d = data(el);
    if (!d) return;
    if (!kurvLest) settKurv(d.iKurv);
    const form = el.closest('form');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    const vid = String(variantId || (idInput && idInput.value) || '');
    const v = d.varianter ? d.varianter[vid] : null;
    const qty = form.querySelector('quantity-input');
    const input = qty ? qty.querySelector('input[name="quantity"]') : null;
    const knapp = form.querySelector('button[name="add"]');

    let modus = 'knapp';
    let maks = null;
    if (v && v.styrt) {
      if (v.selgUtenLager) {
        modus = 'velger';
      } else {
        const iKurv = kurv.get(vid) || 0;
        const rest = (Number(v.lager) || 0) - iKurv;
        if (rest > 1) {
          modus = 'velger';
          maks = rest;
        } else if (rest < 1 && iKurv > 0) {
          modus = 'alle';
        }
      }
    }

    if (qty) {
      qty.hidden = modus !== 'velger';
      if (input) {
        if (maks) input.max = String(maks);
        else input.removeAttribute('max');
        if (variantByttet || modus !== 'velger') input.value = '1';
        else if (maks && Number(input.value) > maks) input.value = String(maks);
      }
    }

    if (!knapp) return;
    if (modus === 'alle') {
      knapp.classList.add('gg-alle-i-kurven');
      knapp.disabled = true;
      knapp.textContent = d.alleIKurven || '';
    } else if (knapp.classList.contains('gg-alle-i-kurven')) {
      knapp.classList.remove('gg-alle-i-kurven');
      // Etter et variantbytte har temaet allerede satt knappen for den nye varianten. Ellers settes den tilbake her.
      if (!variantByttet) {
        knapp.disabled = !(v && v.tilgjengelig);
        if (v && v.tilgjengelig && knapp.dataset.addToCartText) knapp.textContent = knapp.dataset.addToCartText;
      }
    }
  }

  const alle = (variantByttet) => document.querySelectorAll('[data-gg-lager]').forEach((el) => regn(el, null, variantByttet));

  async function lesKurv() {
    const gen = ++kurvGen;
    try {
      const r = await fetch(`${(window.theme && window.theme.routes && window.theme.routes.cart) || '/cart'}.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!r.ok) return;
      const c = await r.json();
      if (gen !== kurvGen) return;
      settKurv(c.items);
      alle(false);
    } catch (e) {
      // behold det vi har
    }
  }

  document.addEventListener('on:variant:change', (evt) => {
    const rot = evt.target.closest('quick-add-drawer, .shopify-section') || document;
    const variant = evt.detail && evt.detail.variant;
    // Etter temaets egen oppdatering av knappen
    setTimeout(() => rot.querySelectorAll('[data-gg-lager]').forEach((el) => regn(el, variant ? variant.id : null, true)), 0);
  });

  const fraKurv = (evt) => {
    if (evt.detail && evt.detail.cart && Array.isArray(evt.detail.cart.items)) {
      kurvGen += 1;
      settKurv(evt.detail.cart.items);
      alle(false);
    } else {
      lesKurv();
    }
  };
  document.addEventListener('on:cart:add', fraKurv);
  document.addEventListener('on:line-item:change', fraKurv);
  document.addEventListener('on:quickbuy:after-open', () => lesKurv());
  window.addEventListener('pageshow', (evt) => {
    if (evt.persisted) lesKurv();
  });

  // Et skrevet antall over restlageret settes ned til restlageret
  document.addEventListener('change', (evt) => {
    const input = evt.target;
    if (!input.matches || !input.matches('quantity-input input[name="quantity"]') || !input.max) return;
    const maks = Number(input.max);
    if (maks > 0 && Number(input.value) > maks) input.value = String(maks);
  });

  // Variantvelgeren setter kjøpsknappen selv i en setTimeout ved oppstart (variant-picker.js), og uten hendelse. Regn etter den, og igjen ved load.
  alle(false);
  setTimeout(() => alle(false), 0);
  window.addEventListener('load', () => setTimeout(() => alle(false), 0));
})();
